export class UpdateDelivererNotes {
    public orderID: number;
    public delivererNotes: string;
}
